const DOCUMENT = 'SECTOR_';

const actions = {
  ADD: DOCUMENT + 'ADD',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',
  CHANGE_NESTED_PROPERTY: DOCUMENT + 'CHANGE_NESTED_PROPERTY',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_STEP: DOCUMENT + 'CHANGE_STEP',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  EDIT: DOCUMENT + 'EDIT',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_SECTOR_PENALTY_RATES_REQUEST: DOCUMENT + 'LOAD_SECTOR_PENALTY_RATES_REQUEST',
  LOAD_SECTOR_PENALTY_RATES_SUCCESS: DOCUMENT + 'LOAD_SECTOR_PENALTY_RATES_SUCCESS',
  UPDATE_SECTOR_PENALTY_RATES_REQUEST: DOCUMENT + 'UPDATE_SECTOR_PENALTY_RATES_REQUEST',
  UPDATE_SECTOR_PENALTY_RATES_SUCCESS: DOCUMENT + 'UPDATE_SECTOR_PENALTY_RATES_SUCCESS',
  PREPARE_DEFAULT_PENALTY_RATE: DOCUMENT + 'PREPARE_DEFAULT_PENALTY_RATE',
  LOAD_SECTOR_POSITIONS: DOCUMENT + 'LOAD_SECTOR_POSITIONS',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_FAIL: DOCUMENT + 'SAVE_FAIL',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  CHECK_UNITS_IN_ORGANIZATION_REQUEST: DOCUMENT + 'CHECK_UNITS_IN_ORGANIZATION_REQUEST',
  CHECK_UNITS_IN_ORGANIZATION_SUCCESS: DOCUMENT + 'CHECK_UNITS_IN_ORGANIZATION_SUCCESS',
  TOGGLE_CONFIRMATION_MODAL: DOCUMENT + 'TOGGLE_CONFIRMATION_MODAL',
  FILTER_POSITIONS: DOCUMENT + 'FILTER_POSITIONS',
  SHOULD_FORCE_CHANGE_PENALTY_RATE_TAB: DOCUMENT + 'SHOULD_FORCE_CHANGE_PENALTY_RATE_TAB',

  add: data => ({ type: actions.ADD, payload: data }),
  cancel: () => ({ type: actions.CANCEL }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
  changeNestedProperty: data => ({ type: actions.CHANGE_NESTED_PROPERTY, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  changeStep: data => ({ type: actions.CHANGE_STEP, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  create: () => ({ type: actions.CREATE }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  loadData: data => ({ type: actions.LOAD, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  loadFormData: data => ({ type: actions.LOAD_FORM_DATA, payload: data }),
  loadSectorPenaltyRates: data => ({ type: actions.LOAD_SECTOR_PENALTY_RATES_REQUEST, payload: data }),
  loadSectorPenaltyRatesSuccess: data => ({ type: actions.LOAD_SECTOR_PENALTY_RATES_SUCCESS, payload: data }),
  updateSectorPenaltyRates: data => ({ type: actions.UPDATE_SECTOR_PENALTY_RATES_REQUEST, payload: data }),
  updateSectorPenaltyRatesSuccess: data => ({ type: actions.UPDATE_SECTOR_PENALTY_RATES_SUCCESS, payload: data }),
  prepareDefaultPenaltyRate: () => ({ type: actions.PREPARE_DEFAULT_PENALTY_RATE }),
  loadSectorPositions: data => ({ type: actions.LOAD_SECTOR_POSITIONS, payload: data }),
  save: data => ({ type: actions.SAVE, payload: data }),
  saveFail: data => ({ type: actions.SAVE_FAIL, payload: data }),
  saveSuccess: data => ({ type: actions.SAVE_SUCCESS, payload: data }),
  checkHowManyUnitsInOrganizationRequest: data => ({
    type: actions.CHECK_UNITS_IN_ORGANIZATION_REQUEST,
    payload: data,
  }),
  checkHowManyUnitsInOrganizationSuccess: data => ({
    type: actions.CHECK_UNITS_IN_ORGANIZATION_SUCCESS,
    payload: data,
  }),
  toggleConfirmationModal: data => ({ type: actions.TOGGLE_CONFIRMATION_MODAL, payload: data }),
  filterPositions: data => ({ type: actions.FILTER_POSITIONS, payload: data }),
  shouldForceChangePenaltyRateTab: () => ({ type: actions.SHOULD_FORCE_CHANGE_PENALTY_RATE_TAB }),
};

export default actions;
